module.exports = __webpack_public_path__ + "img/status_reject.ad372f24.png";